import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ThemeButtonType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_BUTTON = {
  borderThickness: 1,
  borderOpacity: 100,
  borderCornerRadius: 4,
  shadowOpacity: 0,
  shadowHorizontalOffset: 0,
  sahdowVerticalOffset: 4,
  shadowBlur: 5,
  colorScheme: undefined,
};

export default function ThemeButtonSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const button = builder.theme?.button || DEFAULT_THEME_BUTTON;

  const setLayout = (newButton: Partial<ThemeButtonType>) => {
    builder.setTheme({
      button: { ...button, ...newButton },
    });
  };

  return (
    <div>
      <h3 className='mb-2 mt-4 font-bold'>Border</h3>
      <InputSlider
        label='Thickness'
        value={button.borderThickness}
        max={12}
        min={0}
        onChange={(val) => setLayout({ borderThickness: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={button.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner Radius'
        value={button.borderCornerRadius}
        max={40}
        min={0}
        onChange={(val) => setLayout({ borderCornerRadius: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Shadow</h3>
      <p className='text-sm'>Affects areas with multiple columns or rows.</p>
      <InputSlider
        label='Opacity'
        value={button.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setLayout({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal Offset'
        value={button.shadowHorizontalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ shadowHorizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical Offset'
        value={button.sahdowVerticalOffset}
        max={12}
        min={-12}
        onChange={(val) => setLayout({ sahdowVerticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Shadow Blur'
        value={button.shadowBlur}
        max={20}
        min={0}
        onChange={(val) => setLayout({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={button.colorScheme}
        onChange={(theme) => {
          setLayout({ colorScheme: theme });
        }}
      />
      <div className='mb-4 mt-1 text-xs'>
        To edit all your theme&apos;s colors, go to your color theme settings.
      </div>
    </div>
  );
}
